import axios from 'axios';
axios.defaults.withCredentials = true;
import {configure, observable, action, runInAction} from 'mobx';
configure({enforceActions: 'always'});
import getCurrentCoords from 'utils/getCurrentCoords';
import {getDistance, smartJump, checkLogin, getQueryString} from 'utils/utils';
import {CONFIGPOS} from '../config';
import Toast from 'components/Toast';
import Popup from 'components/Popup';
import ImagePopup from 'components/MiniProgramImage';
import {
    getDetail,
    getUdetail,
    getReceive
} from '../../common/action';
import openUrl from 'utils/open';

// scheme打开页面
if(getQueryString('et') === 'wb_oppo_sqtg' ) {
    document.title = 'O粉节带你全国游';
    if(!hysdk.sniff.qunar) {
        const url = location.href;
        openUrl(`//hy?url=${encodeURIComponent(url)}&ad_channel=oppofuli&ad_type=04&ad_other=`);
    }
}

function formatSk(comp, key, index) {
    let str = '';
    switch(comp) {
        case 'sqtqd':
            str = 'sqtqd_tab' + index;
            break;
        case 'sqwzb':
            str = 'sqwzb_tab' + index;
            break;
        case 'rxtj':
            if(key === 'hrSecondTab') {
                return;
            }
            str = '24hrx_tab' + index;
            break;
        case 'bqdlc':
            str = 'bqd_tab' + index;
            break;
        case 'bdlw':
            str = 'bdlw_tab' + index;
            break;
        case 'jzbblc':
            str = 'jzbb_tab' + index;
            break;
    }
    sendSK('click_' + str);
}

const initHash = {
    waterFallData: [],
    rxtj: {
        hrSecondTab: [],
        hrFirstTab: [],
        rxtjad: [],
        pros: [],
        order: ['hrFirstTab', 'hrSecondTab']
    },
    ymbj: [],
    vouchers: [],
    sqtqd: {
        sqtqdFirstTab: [],
        pros: [],
        order: ['sqtqdFirstTab']
    },
    sqwzb: {
        sqwzbFirstTab: [],
        pros: [],
        order: ['sqwzbFirstTab']
    },
    bqdlc: {
        bqdlcFirstTab: [],
        pros: [],
        order: ['bqdlcFirstTab']
    },
    jzbblc: {
        jzbblcFirstTab: [],
        pros: [],
        order: ['jzbblcFirstTab']
    },
    bdlw: {
        bdlwFirstTab: [],
        pros: [],
        order: ['bdlwFirstTab']
    },
    xtbk: [],
    gnrmmdd: [],
    sqdw: [],
    ggwlc: [],
    syggpz: [],
    footerImgs: []
};
class Store {
    constructor() {
        this.detailExtKey = 'SHUCU';
    }
    @observable dep = '北京';
    @observable deps = [];
    @observable showRules = false;
    @observable loading = false;
    @observable hasMore = true;
    @observable waterFallData = [];
    @observable pageNum = 0;
    @observable isOppo = getQueryString('et') === 'wb_oppo_sqtg';// 是否是opp推广
    // 热销推荐
    @observable rxtj = {
        hrSecondTab: [
        ],
        hrFirstTab: [],
        rxtjad: [],
        pros: [],
        order: ['hrFirstTab', 'hrSecondTab']
    };

    @observable ymbj = {};

    @observable currentModule = '';
    @observable userCashBatch = '';

    @observable vouchers = [];
    @observable voucherShow = false;
    @observable hasReceived = false;

    // 暑期提前订
    @observable sqtqd = {
        sqtqdFirstTab: [],
        pros: [],
        order: ['sqtqdFirstTab']
    }
    // 暑期玩周边
    @observable sqwzb = {
        sqwzbFirstTab: [],
        pros: [],
        order: ['sqwzbFirstTab']
    }
    // 不确定楼层
    @observable bqdlc = {
        bqdlcFirstTab: [],
        pros: [],
        order: ['bqdlcFirstTab']
    }
    // 金主楼层
    @observable jzbblc = {
        jzbblcFirstTab: [],
        pros: [],
        order: ['jzbblcFirstTab']
    };
    // 本地遛弯（常规模块版小驼爆款）
    @observable bdlw = {
        bdlwFirstTab: [],
        pros: [],
        order: ['bdlwFirstTab']
    }
    // 小驼爆款
    @observable xtbk = [];
    // 国内热门目的地
    @observable gnrmmdd = [];
    // 暑期带娃不用愁
    @observable sqdw = [];
    @observable ggwlc = [];
    @observable syggpz = [];

    @observable footerImgs = [];

    @action.bound async init() {
        this.getDeps();
    }

    initData() {
        this.getBgModule(); // 页面配置
        this.getVouchers();
        this.getXtbk(); // 获取小驼爆款
        this.getBdlw(); // 获取本地遛弯楼层数据
        this.getSqtq(); // 获取暑期提前
        this.getSqwzb(); // 获取暑期周边
        this.getBqdlc(); // 获取不确定楼层数据
        this.getJzbblc(); // 获取金主爸爸楼层数据

        this.getAds(); // 广告数据
        this.getSyggpz(); // 所有楼层的额外广告位数据

        this.getGnrmmdd(); // 获取国内热门目的地
        this.getSqdw(); // 暑期带娃数据
        this.getBackGroundData(); // List 一级tab
    }

    @action.bound getVouchers() {
        getUdetail({
            pos: 'sqdczhc',
            modules: 'dplmqpz',
            utypes: 7,
            from: '06_shuchu'
        }).then(({data: res}) => {
            if (res.status === 0) {
                runInAction(() => {
                    const {data: {dplmqpz=[]}={}} = res;
                    let vouchers = [];
                    dplmqpz.forEach(item => {
                        const forData = item.data || [];
                        forData.forEach(f => {
                            const {coupon} = f || {};
                            coupon && (vouchers.push(coupon));
                            if (coupon && coupon.receiveStatus && coupon.receiveStatus !== 'UNRECEIVED') {
                                this.hasReceived = true;
                            }
                        });
                    });
                    this.vouchers = vouchers;
                });
            };
        });
    }
    @action.bound receive() {
        const cabcs = this.vouchers.map(item => item.code);
        if (!cabcs.length) return;
        checkLogin().then(res => {
            if(!res) {
                window.loginSuccessCallback = async() => {
                    await this.getVouchers();
                    this.receive();
                };
                return;
            }
            getReceive({
                from: '06_shuchu',
                pos: 'sqdczhc',
                modules: 'dplmqpz',
                cabcs: cabcs.join(',')
            })
                .then(({data: res}) => {
                    if(res.status === 0) {
                        runInAction(() => {
                            this.changeVoucherShow(true);
                            Toast.show('领取成功');
                            this.hasReceived = true;
                        });
                    }else{
                        Toast.show(res.message);
                    }
                });
        });
    }
    @action.bound changeVoucherShow(flag) {
        this.voucherShow = flag;
    }

    @action.bound getLocalCoords() {
        getCurrentCoords().then(res => {
            runInAction(async() => {
                const {latitude, longitude} = res;
                if(latitude && longitude) {
                    const min = this.deps.concat().map(item => {
                        return {
                            ...item,
                            distance: getDistance(`${item.latitude},${item.longitude}`, `${latitude},${longitude}`)
                        };
                    }).sort((a, b) => {
                        return a.distance - b.distance;
                    }).shift() || {};
                    this.dep = min.name || '北京';

                    this.initData();
                }
            });
        });
    }

    @action.bound getDeps() {
        return getDetail({
            pos: CONFIGPOS,
            modules: 'deps'
        }).then(res => {
            const {data} = res;
            if(data.status === 0) {
                const {deps = {}} = data.data || {};
                runInAction(() => {
                    let allDeps = [];
                    Object.keys(deps).forEach(item => {
                        allDeps = allDeps.concat(deps[item]);
                    });
                    this.deps = allDeps.map(item => {
                        return {
                            mid: item.mid,
                            id: item.id,
                            ...item.data
                        };
                    });
                    this.getLocalCoords();
                });
            }
        }).catch((err) => {
            console.log(err);// eslint-disable-line
        });
    }

    @action.bound setModule(value) {
        this.currentModule = value;
    }

    resetData() {
        runInAction(() => {
            Object.keys(initHash).forEach((key) => {
                this[key] = initHash[key];
            });
        });
    }

    @action.bound async setDep(dep) {
        this.dep = dep;
        this.resetData();
        this.initData();
    }

    @action.bound toggleShowRules() {
        this.showRules = !this.showRules;
    }

    @action.bound tabClick(compName, key, index) {
        if(!this[compName]) return;
        this.setTabItem(compName, key, index);
        this.getMoreData(compName, key, index);
        formatSk(compName, key, index);
    }

    getMoreData(compName, key) {
        switch(compName) {
            case 'sqtqd':
                this.getCommoncp('sqtqdcppz', 'pros', 'sqtqd', 'sqtqdFirstTab');
                break;
            case 'sqwzb':
                this.getCommoncp('sqwzbcppz', 'pros', 'sqwzb', 'sqwzbFirstTab');
                break;
            case 'rxtj':
                this.resetWaterFallData();
                if(key === 'hrFirstTab') {
                    this.getRxtjSecondTab(true);
                } else {
                    this.getWaterFallData(true);
                }
            case 'bqdlc':
                this.getCommoncp('bqdlccp', 'pros', 'bqdlc', 'bqdlcFirstTab');
                break;
            case 'bdlw':
                this.getCommoncp('bdlwtjcp', 'pros', 'bdlw', 'bdlwFirstTab');
                break;
            case 'jzbblc':
                this.getCommoncp('jzbblctjcp', 'pros', 'jzbblc', 'jzbblcFirstTab');
                break;
        }
    }
    // 设置某一个tab 的值
    setTabItem(compName, key, index) {
        const tabs = this[compName][key] || [];
        if(!tabs.length) return;
        if(tabs[index] && tabs[index].checked) return;
        if(index === -1) index = 0;
        tabs.forEach(item => item.checked = false);
        tabs[index].checked = true;
        this[compName] = Object.assign({}, {
            ...this[compName],
            [key]: tabs
        });
    }


    getCheckItem(compName, key) {
        if(!this[compName] || !this[compName][key]) return {};
        let result = this[compName][key], item = {};
        result.forEach((val) => {
            if(val.checked) {
                item = val;
            }
        });
        return item;
    }

    // 重置瀑布流数据
    resetWaterFallData() {
        this.pageNum = 0;
        this.hasMore = true;
        this.waterFallData = [];
    }

    // 热销推荐广告配置
    @action.bound getRxtjAds() {
        getDetail({
            dep: this.dep,
            pos: CONFIGPOS,
            modules: 'rxtjggpz'
        })
            .then(({data: res}) => {
                const {status, data} = res;
                if(status === 0 && data) {
                    runInAction(() => {
                        Object.assign(this.rxtj, {
                            rxtjad: data.rxtjggpz.map((val) => ({
                                ...val,
                                ...val.data,
                                type: 'ad',
                                thumb: val.data.img
                            }))
                        });
                        this.getRxtjFirstTab();
                    });
                    return;
                }
                this.getRxtjFirstTab();
            });
    }
    // list 后台配置 一级tab
    @action.bound getBackGroundData() {
        getDetail({
            dep: this.dep,
            pos: CONFIGPOS,
            modules: 'rxtjbqpz'
        })
            .then(({data: res}) => {
                const {status, data} = res;
                if(status === 0) {
                    runInAction(() => {
                        Object.assign(this.rxtj, {
                            hrFirstTab: data.rxtjbqpz.map((val) => ({
                                ...val,
                                ...val.data,
                                value: val.data.val
                            }))
                        });

                        this.getRxtjAds();
                    });
                }
            });
    }

    // list 一级tab
    @action.bound getRxtjFirstTab() {
        axios({
            url: '/golfz/routeList',
            method: 'GET',
            params: {
                dep: this.dep,
                modules: 'marketTag'
            }
        })
            .then(({data: res}) => {
                const {ret, data} = res;
                if(ret) {
                    let {marketTag} = data;
                    marketTag = marketTag.map((val) => ({
                        value: val.value,
                        title: val.name
                    }));

                    let originData = this.rxtj.hrFirstTab;
                    let result = [], sum = 0;
                    originData.forEach((val) => {
                        let t = marketTag.filter((s) => +val.value === +s.value);
                        if(t.length > 0) {
                            result.push({
                                ...val,
                                checked: sum === 0
                            });
                            sum++;
                        }
                    });
                    runInAction(() => {
                        Object.assign(this.rxtj, {
                            hrFirstTab: result
                        });
                        this.getRxtjSecondTab();
                    });
                }
            });
    }

    // list 二级tab
    @action.bound getRxtjSecondTab() {
        const marketTag = this.getCheckItem('rxtj', 'hrFirstTab');
        if(!marketTag || !marketTag.value) return;
        axios({
            url: '/golfz/routeList',
            method: 'GET',
            params: {
                dep: this.dep,
                modules: 'city',
                marketTag: marketTag.value
            }
        })
            .then(({data: res}) => {
                const {ret, data} = res;
                if(ret) {
                    const {city} = data;
                    runInAction(() => {
                        this.rxtj = Object.assign(this.rxtj, {
                            hrSecondTab: city.map((item, index) => ({
                                ...item,
                                title: item.value,
                                checked: index === 0
                            }))
                        });
                        this.getWaterFallData();
                    });
                }
            });
    }

    // 请求瀑布流数据
    @action.bound getWaterFallData() {
        const hrSecondTab = this.getCheckItem('rxtj', 'hrSecondTab');
        const marketTag = this.getCheckItem('rxtj', 'hrFirstTab');
        this.loading = true;
        axios({
            url: '/golfz/routeList',
            method: 'GET',
            params: {
                dep: this.dep,
                depQueryRank: this.dep + '-' + hrSecondTab.title,
                modules: 'list',
                marketTag: marketTag.value,
                city: hrSecondTab.title,
                limit: this.pageNum + ',10'
            }
        })
            .then(({data: res}) => {
                const {ret, data} = res;
                runInAction(() => {
                    if(ret) {
                        const{results} = data.list;
                        this.waterFallData = this.waterFallData.concat(results);
                        results.length < 10 && (this.hasMore = false);

                        this.pageNum += 10;
                    }
                    this.loading = false;
                });
            });
    }

    // 加载更多数据
    @action.bound loadMore() {
        this.getWaterFallData();
    }

    // 获取模块的背景
    @action.bound getBgModule() {
        getDetail({
            pos: CONFIGPOS,
            modules: 'bjpz,dbxd'
        })
            .then(({data: res}) => {
                const {data, status} = res;
                if(status === 0) {
                    runInAction(() => {
                        const {dbxd=[]} = data;
                        this.ymbj = data.bjpz && data.bjpz[0] && data.bjpz[0].data;
                        this.footerImgs = dbxd[0] && dbxd[0].data || [];
                    });
                }
            });
    }

    // 获取暑期提前订数据
    @action.bound getSqtq() {
        this.getCommonBq('sqtqdbqpz', 'sqtqdFirstTab', 'sqtqd', () => {
            this.getCommoncp('sqtqdcppz', 'pros', 'sqtqd', 'sqtqdFirstTab');
        });
    }

    // 获取暑期玩周边数据
    @action.bound getSqwzb() {
        this.getCommonBq('sqwzbbqpz', 'sqwzbFirstTab', 'sqwzb', () => {
            this.getCommoncp('sqwzbcppz', 'pros', 'sqwzb', 'sqwzbFirstTab');
        });
    }

    // 获取不确定楼层数据
    @action.bound getBqdlc() {
        this.getCommonBq('bqdlcbq', 'bqdlcFirstTab', 'bqdlc', () => {
            this.getCommoncp('bqdlccp', 'pros', 'bqdlc', 'bqdlcFirstTab');
        });
    }

    // 获取金主爸爸楼层数据
    @action.bound getJzbblc() {
        this.getCommonBq('jzbblcbq', 'jzbblcFirstTab', 'jzbblc', () => {
            this.getCommoncp('jzbblctjcp', 'pros', 'jzbblc', 'jzbblcFirstTab');
        });
    }

    // 获取本地遛弯楼层数据
    @action.bound getBdlw() {
        this.getCommonBq('bdlwtjbq', 'bdlwFirstTab', 'bdlw', () => {
            this.getCommoncp('bdlwtjcp', 'pros', 'bdlw', 'bdlwFirstTab');
        });
    }

    // 获取小驼爆款楼层数据
    @action.bound getXtbk() {
        return getDetail({
            dep: this.dep,
            modules: 'xtbkmk',
            pos: CONFIGPOS,
            types: 4
        }).then(({data: res}) => {
            if(res.status === 0) {
                const {xtbkmk = []} = res.data || {};
                runInAction(() => {
                    this.xtbk = xtbkmk[0] && xtbkmk[0].data;
                });
            }
        });
    }

    // 国内热门目的地
    @action.bound getGnrmmdd() {
        getDetail({
            dep: this.dep,
            pos: CONFIGPOS,
            modules: 'gnrmmddjxpz',
            types: '14'
        })
            .then(({data: res}) => {
                const {data, status} = res;
                if(status === 0 && data) {
                    runInAction(() => {
                        this.gnrmmdd = data['gnrmmddjxpz'].map((val) => ({
                            ...val,
                            ...val.data
                        }));
                    });
                }
            });
    }

    // 获取广告位数据
    @action.bound getAds() {
        getDetail({
            dep: this.dep,
            pos: CONFIGPOS,
            modules: 'gglcpz'
        })
            .then(({data: res}) => {
                const {data, status} = res;
                if(status === 0 && data) {
                    runInAction(() => {
                        // 广告数据
                        this.ggwlc = data.gglcpz.map((val) => ({
                            ...val,
                            ...val.data
                        }));
                    });
                }
            });
    }

    // 获取所有楼层的广告位数据
    @action.bound getSyggpz() {
        getDetail({
            dep: this.dep,
            pos: CONFIGPOS,
            modules: 'syggpz'
        })
            .then(({data: res}) => {
                const {data, status} = res;
                if(status === 0 && data) {
                    runInAction(() => {
                        this.syggpz = (data.syggpz || [{}])[0].data || [];
                    });
                }
            });
    }

    // 获取暑期带娃数据
    @action.bound getSqdw() {
        getDetail({
            dep: this.dep,
            pos: CONFIGPOS,
            modules: 'sqdwbyc'
        })
            .then(({data: res}) => {
                const {data, status} = res;
                if(status === 0) {
                    runInAction(() => {
                        this.sqdw = data['sqdwbyc'] ? data['sqdwbyc'][0].data : [];
                    });
                }
            });
    }

    // 获取标签
    @action.bound getCommonBq(moduleName, dataKey, pageKey, cb) {
        getDetail({
            dep: this.dep,
            pos: CONFIGPOS,
            modules: moduleName
        })
            .then(({data: res}) => {
                const {data, status} = res;
                if(status === 0 && data) {
                    runInAction(() => {
                        Object.assign(this[pageKey], {
                            [dataKey]: data[moduleName].map((val, index) => ({
                                ...val,
                                ...val.data,
                                checked: index === 0
                            }))
                        });
                        cb && cb();
                    });
                }
            });
    }

    // 获取产品
    @action.bound getCommoncp(moduleName, dataKey, pageKey, preDataKey, params = {}) {
        let pid = this.getCheckItem(pageKey, preDataKey).id;
        getDetail({
            dep: this.dep,
            pos: CONFIGPOS,
            modules: moduleName,
            pid,
            ...params
        }, this.detailExtKey)
            .then(({data: res}) => {
                const {data, status} = res;
                if(status === 0) {
                    runInAction(() => {
                        Object.assign(this[pageKey], {
                            [dataKey]: data[moduleName][pid].map((val) => ({
                                ...val,
                                ...val.data,
                                ...val.data.detail
                            }))
                        });
                    });
                }
            }).catch(()=> {
                runInAction(() => {
                    Object.assign(this[pageKey], {
                        [dataKey]: []
                    });
                });
            });
    }

    jump(data, it) {
        let url = typeof data === 'string' ? data : hysdk.sniff.scheme ? (data.appUrl || data.touchUrl) : data.touchUrl;
        it && (url += `${url.match(/\?/) ? '&' : '?'}it=${it}`);
        if (/\.(png|jpg|jpeg|gif)$/i.test(url)) {
            Popup.show(ImagePopup, {
                url
            });
            return;
        }
        smartJump(url, url.includes('browser') ? 'browser' : 'navibar-none');
    }
}

export default new Store();